import { useState } from 'react'

import type { UserConsultBlockItemResponse } from '@/api/model/chatType'
import Toast from '@/components/common/toast/ToastMessage'
import { TOPIC_PREPARING_MESSAGE } from '@/utils/toastMessages'

interface ChatTopicGridProps {
  selectedTopic: number | null
  onTopicSelect: (topicId: number, topicTitle: string) => void // topicTitle 추가
  topics: UserConsultBlockItemResponse[]
  activeTopic?: number
}

export default function ChatTopicGrid({ selectedTopic, onTopicSelect, topics, activeTopic }: ChatTopicGridProps) {
  const [showToast, setShowToast] = useState(false)

  // 비활성화할 토픽 이름 목록
  const disabledTopics = ['미래와 진로', '공부 방법', '목표와 실천', '실천 행동', '목표 설정']

  // 토픽이 비활성화되어야 하는지 확인하는 함수
  const isTopicDisabled = (topicName: string) => {
    return disabledTopics.includes(topicName)
  }

  // 토픽 클릭 핸들러
  const handleTopicClick = (topic: UserConsultBlockItemResponse) => {
    if (isTopicDisabled(topic.name)) {
      setShowToast(true)
    } else {
      onTopicSelect(topic.block_id, topic.name)
    }
  }

  return (
    <>
      <div className='grid grid-cols-2 gap-3'>
        {topics.map(topic => {
          const isDisabled = isTopicDisabled(topic.name)

          return (
            <button
              key={topic.block_id}
              onClick={() => handleTopicClick(topic)}
              className={`p-4 rounded-2xl text-center transition-colors duration-200 ${
                isDisabled
                  ? 'bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed opacity-80'
                  : selectedTopic === topic.block_id
                    ? 'bg-amber-200 text-amber-900 shadow-md border-2 border-amber-300 scale-[1.03] ring-2 ring-amber-200'
                    : activeTopic && activeTopic === topic.block_id
                      ? 'bg-amber-800 text-white '
                      : 'bg-white hover:bg-amber-50 text-gray-700 border border-gray-200 hover:border-amber-100'
              }`}
            >
              <div className='space-y-3'>
                <p
                  className={`text-sm font-medium leading-relaxed ${
                    isDisabled
                      ? 'text-gray-400'
                      : selectedTopic === topic.block_id
                        ? 'text-amber-800'
                        : activeTopic && activeTopic === topic.block_id
                          ? ' text-white'
                          : 'text-gray-700'
                  }`}
                >
                  {topic.desc}
                </p>
                <p
                  className={`text-xs ${
                    isDisabled
                      ? 'text-gray-400'
                      : selectedTopic === topic.block_id
                        ? 'text-amber-600'
                        : activeTopic && activeTopic === topic.block_id
                          ? ' text-gray-200'
                          : 'text-gray-500'
                  }`}
                >
                  {topic.name}
                </p>
              </div>
            </button>
          )
        })}
      </div>

      <Toast
        message={TOPIC_PREPARING_MESSAGE}
        isVisible={showToast}
        onClose={() => setShowToast(false)}
        duration={2000}
      />
    </>
  )
}
